import PropTypes from 'prop-types';
import React from 'react';
import { hoursType } from '@types/index';

import MuseumHours from '@components/MuseumHours';
import DropNavigationList from '../Header/Elements/DropNavigationList';
import StaticNavigationList from './Elements/StaticNavigationList';
import MobileMenuLayout from './Elements/MobileMenuLayout';
import './index.scss';

const MobileNavigation = ({ data, hours }) => {
  const dropDownNavigation = [];
  const staticNavigation = [];
  data.forEach((item) => {
    if (item.type === 'Multiple') {
      dropDownNavigation.push(item);
    } else {
      staticNavigation.push(item);
    }
  });

  const classNames = {
    drop: 'mx-0 w-100',
    toggle: 'menu-item px-3 px-xl-0',
    nav: '',
    menu: 'px-0 py-1 border-0',
    wrapper: '',
  };

  return (
    <MobileMenuLayout>
      <>
        <div className="px-3">
          <MuseumHours hours={hours} isMobileNav />
          <DropNavigationList
            itemData={dropDownNavigation}
            classNames={classNames}
            isNavbar
            isMobileNav
          />
        </div>
        <StaticNavigationList
          items={staticNavigation}
        />
      </>
    </MobileMenuLayout>
  );
};

const dataType = PropTypes.shape({ type: PropTypes.string });

MobileNavigation.defaultProps = {
  hours: null,
};

MobileNavigation.propTypes = {
  data: PropTypes.arrayOf(dataType).isRequired,
  hours: hoursType,
};

export default MobileNavigation;
